export enum WebhookEventsTableActionType {
  ChangeSortingType = 'webhookEventsTable/changeSortingType',
  ResetState = 'webhookEventsTable/resetState',
}
